import { useTranslation } from 'react-i18next';
import Table from 'react-bootstrap/Table';

export const SoonExpiredProductsTable = ({ products }) => {

    const { t } = useTranslation('homePage');

    return (
        <div className={'expired-products-container'}>
            {products != null && products.length > 0
                ? <div>
                    <h4 className={'center'}>{t('expiredProducts')}</h4>
                    <Table striped bordered hover>
                        <thead>
                        <tr>
                            <th>{t('expired.productTitle')}</th>
                            <th>{t('expired.expireAt')}</th>
                            <th>{t('expired.amountInWarehouse')}</th>
                            <th>{t('expired.invoice')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {products.map((product, index) => {
                            return (
                                <tr key={index}>
                                    <td key={'title' + index}>{product.title}</td>
                                    <td key={'expireAt' + index}>{product.expireAt}</td>
                                    <td key={'amountInWarehouse' + index}>{product.amountInWarehouse}</td>
                                    <td key={'invoice' + index}>{product.invoice}</td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </Table>
                </div>
                : <div>
                    <h4 className={'center'}>{t('noExpiredProducts')}</h4>
                </div>
            }
        </div>
    );
};